import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

// Rotate in the map's local metric plane. KML angles are counterclockwise;
// screen y increases downwards, so the CSS angle has the opposite sign.
export default function RotatedOverlay({ raster, opacity, zIndex }) {
  const map = useMap();
  useEffect(() => {
    const layer = new L.Layer();
    let image;
    const update = () => {
      const nw = map.latLngToLayerPoint([raster.bounds[1][0], raster.bounds[0][1]]);
      const se = map.latLngToLayerPoint([raster.bounds[0][0], raster.bounds[1][1]]);
      image.style.width = `${se.x - nw.x}px`;
      image.style.height = `${se.y - nw.y}px`;
      image.style.transform = `translate(${nw.x}px, ${nw.y}px) rotate(${-raster.rotation}deg)`;
    };
    layer.onAdd = () => {
      image = L.DomUtil.create('img', 'leaflet-image-layer leaflet-zoom-hide');
      image.alt = raster.name || 'Plan';
      image.src = raster.url;
      image.style.transformOrigin = '50% 50%';
      image.style.opacity = opacity * (raster.opacity ?? 1);
      image.style.zIndex = zIndex;
      image.style.pointerEvents = 'none';
      map.getPane('overlayPane').appendChild(image);
      map.on('zoomend viewreset', update);
      update();
    };
    layer.onRemove = () => {
      map.off('zoomend viewreset', update);
      image.remove();
    };
    layer.addTo(map);
    return () => map.removeLayer(layer);
  }, [map, raster, opacity, zIndex]);
  return null;
}
